module.exports = __webpack_public_path__ + "static/media/Dacia-Duster-side.58c63e0e.jpg";